module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epigraph"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('em', [_vm._v("After sleep, after amnesia, after inhabiting different worlds, I no longer know what truth there is in memory. I believe things I didn’t believe before. About what is outside us. About what is inside. It is a new geography, that of the forgetting body and mind, the remembering spirit, a new landscape.")])]), _vm._v(" "), _c('p', {
    staticClass: "attribute"
  }, [_vm._v("—"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LINDA HOGAN, "), _c('em', [_vm._v("THE WOMAN WHO WATCHES OVER THE WORLD: A NATIVE MEMOIR")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56d4718d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9780292799325_08_fm2.vue
// module id = 81
// module chunks = 0